/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface DateRange
 */
export interface DateRange {
    /**
     * 
     */
    start?: Date;
    /**
     * 
     */
    end?: Date;
    /**
     * 
     */
    qualifier_code?: number;
    /**
     * 
     */
    qualifier_code_definition?: string;
    /**
     * 
     */
    calendar_year?: string;
}

/**
 * Check if a given object implements the DateRange interface.
 */
export function instanceOfDateRange(value: object): value is DateRange {
    return true;
}

export function DateRangeFromJSON(json: any): DateRange {
    return DateRangeFromJSONTyped(json, false);
}

export function DateRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateRange {
    if (json == null) {
        return json;
    }
    return {
        
        'start': json['start'] == null ? undefined : (parseDate(json['start'])),
        'end': json['end'] == null ? undefined : (parseDate(json['end'])),
        'qualifier_code': json['qualifier_code'] == null ? undefined : json['qualifier_code'],
        'qualifier_code_definition': json['qualifier_code_definition'] == null ? undefined : json['qualifier_code_definition'],
        'calendar_year': json['calendar_year'] == null ? undefined : json['calendar_year'],
    };
}

export function DateRangeToJSON(json: any): DateRange {
    return DateRangeToJSONTyped(json, false);
}

export function DateRangeToJSONTyped(value?: DateRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start': value['start'] == null ? value['start'] : serializeDate(value['start']),
        'end': value['end'] == null ? value['end'] : serializeDate(value['end']),
        'qualifier_code': value['qualifier_code'],
        'qualifier_code_definition': value['qualifier_code_definition'],
        'calendar_year': value['calendar_year'],
    };
}

